import { ShoppingCartOutlined } from '@ant-design/icons';
import { App as AntApp, Button, Tooltip } from 'antd';
import { useCart } from '../../cart-store';
import { useCanAfford } from '../../hooks';
import type { Sku } from '../../types';
import { formatPoints } from '../../utils';

type Props = {
  sku: Sku;
  size?: 'middle' | 'large';
  block?: boolean;
};

export const AddToCartButton = ({ sku, size = 'middle', block = false }: Props) => {
  const { affordable, shortfall } = useCanAfford(sku.price);
  const add = useCart((s) => s.add);
  const { message } = AntApp.useApp();

  const outOfStock = sku.stock <= 0;

  const onAdd = () => {
    add(sku);
    message.success(`Added "${sku.title}" to your cart`);
  };

  const button = (
    <Button
      type="primary"
      size={size}
      block={block}
      icon={<ShoppingCartOutlined />}
      disabled={outOfStock || !affordable}
      onClick={onAdd}
    >
      {outOfStock ? 'Out of stock' : 'Add to cart'}
    </Button>
  );

  if (outOfStock || affordable) return button;

  return (
    <Tooltip title={`You need ${formatPoints(shortfall)} more to afford this`}>
      <span style={{ display: block ? 'block' : 'inline-block', cursor: 'not-allowed' }}>{button}</span>
    </Tooltip>
  );
};
